(() => {
  const placeLiveReviewBadge = () => {
    const section = document.querySelector('section[id^="IPS-GoogleReviews-"]');
    const mount = section && section.querySelector('.ips-google-reviews__app-block');
    const badge = document.querySelector('.agrs__badge');

    if (mount && badge && !mount.contains(badge)) {
      mount.appendChild(badge);
    }
  };

  placeLiveReviewBadge();

  const observer = new MutationObserver(placeLiveReviewBadge);
  observer.observe(document.body, { childList: true });

  window.setTimeout(placeLiveReviewBadge, 250);
  window.setTimeout(placeLiveReviewBadge, 1000);
  window.setTimeout(placeLiveReviewBadge, 2500);
  document.addEventListener('shopify:section:load', placeLiveReviewBadge);
  window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
})();
